// src/composables/useLang.js
import { useI18n } from 'vue-i18n'
import { watch } from 'vue'

export function useLang() {
  // 自动获取main.js中挂载的i18n实例
  const { locale, t } = useI18n()

  // 封装语言切换方法（和你原有逻辑一致）
  function setLang(lang) {
    locale.value = lang
    localStorage.setItem('siteLang', lang)
  }

  // 封装语言监听方法
  function watchLangChange(callback) {
    watch(locale, callback, { immediate: true })
  }

  return {
    lang: locale,
    t,
    setLang,
    watchLangChange
  }
}